export default __webpack_public_path__ + "static/media/CV6.a9f35b89.png";